import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { Tag } from 'src/app/api/linkable-tag.service';


@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagComponent implements OnInit {

  constructor() { }



  @Input() tag: Tag = { id: 0, name: "" };
  @Input() editMode = false;

  @Output() remove = new EventEmitter<Tag>();

  isMouseHover = signal(false);

  ngOnInit(): void {
  }

  mouseEnter() {
    this.isMouseHover.set(true);
  }

  mouseLeave() {
    this.isMouseHover.set(false);
  }

  removeTag(tag: Tag) {
    this.remove.emit(tag);
  }

}
